<template>
  <div>
    <el-dialog
      visible
      v-if="RTformOpen"
      center
      :title="$t('templateTaskForm.taskParams')"
      append-to-body
      :show-close="false"
    >
      <run-task-form
        fromCron
        @close="RTformOpen = false"
        @paramLine="setParamLine"
      ></run-task-form>
    </el-dialog>
    <el-dialog
      visible
      v-if="tasksFlag"
      :title="
        $t('templateTaskForm.editTemplateTasks') + ' ' + selectedTemplate.name
      "
      @close="cancelTaskClick"
      :close-on-click-modal="false"
    >
      <el-form label-position="left" class="main-form-scroll">
        <div>
          <div>
            <div
              v-for="(task, index) in templateTaskArray"
              :key="index"
              class="el-form-line"
              :ref="'task' + index"
            >
              <el-select
                v-model="task.caption"
                :placeholder="$t('templateTaskForm.taskNotSelected')"
                @change="pTaskSelected(task)"
                filterable
              >
                <el-option
                  v-for="(task1, index) in packetableTaskList"
                  :key="index"
                  :value="task1.caption"
                  :label="task1.caption"
                ></el-option>
              </el-select>
              <div>Path: {{ task.path }}</div>
              <div>Params: {{ task.params }}</div>
              <div class="buttons">
                <el-button
                  @click="addTask(task)"
                  icon="el-icon-plus"
                  size="mini"
                ></el-button>
                <el-button
                  @click.prevent="
                    removeElement(task, templateTaskArray, addTask)
                  "
                  icon="el-icon-delete"
                  size="mini"
                ></el-button>
                <el-button
                  @click.prevent="moveUp(task, templateTaskArray)"
                  icon="el-icon-top"
                  size="mini"
                ></el-button>
                <el-button
                  @click.prevent="moveDown(task, templateTaskArray)"
                  icon="el-icon-bottom"
                  size="mini"
                ></el-button>
                <!-- <span class="nn-index">[{{index}}]</span> -->
                <el-button @click="callRunTaskForm(task, index)">{{
                  $t("templateTaskForm.enterParams")
                }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="bottom-buttons">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="cancelTaskClick"
            >{{ $t("templateTaskForm.cancel") }}</el-button
          >
          <el-button class="button-confirm" type="success" @click="okTaskClick"
            >OK</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RunTaskForm from "../tasks/RunTaskForm";
import { mapGetters } from "vuex";
import arrayWorkMixin from "./arrayWorkMixin";
export default {
  data() {
    return {
      RTformOpen: false,
      templateTaskArray: [],
      // templateApp: null,
      showPTasks: false,
      taskSelected: null,
    };
  },
  methods: {
    setTemplateTasks() {
      this.templateTaskArray = [];
      if (this.templateInfo.tasks && this.templateInfo.tasks.length > 0) {
        for (let ob of this.templateInfo.tasks) {
          // console.log(ob);
          // console.log(this.packetableTaskList);
          let task = {
            id: this.packetableTaskList.find(
              (task) => task.caption === ob.caption
            ).id,
            caption: ob.caption,
            path: ob.path,
            params: ob.params,
          };
          // console.log(task);
          this.templateTaskArray.push(task);
        }
      } else {
        this.addTask();
      }
    },
    pTaskSelected(pTask) {
      // console.log("SELECT");
      // console.log(this.packetableTaskList);
      pTask.id = this.packetableTaskList.find(
        (task) => task.caption === pTask.caption
      ).id;
      pTask.path = this.packetableTaskList.find(
        (task) => task.caption === pTask.caption
      ).path;
      pTask.params = null;
      // console.log(pTask);
    },
    addTask(task) {
      // //console.log(this.paramLines);
      let index = this.templateTaskArray.indexOf(task);
      // //console.log(param);
      this.templateTaskArray.splice(index + 1, 0, {
        id: null,
        caption: null,
        path: null,
        params: null,
      });
      const ref = `task${index + 1}`;
      this.$nextTick()
        .then(() => {
          const newElement = this.$refs[ref];
          newElement[0].scrollIntoView();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    callRunTaskForm(task, index) {
      this.$store.dispatch("getCmdLine", task.id).then(() => {
        task.index = index;
        this.taskSelected = task;
        this.RTformOpen = true;
      });
    },
    setParamLine(paramLine) {
      // console.log("PARAM LINE: ", paramLine);
      this.RTformOpen = false;
      let pTask = this.templateTaskArray.find(
        (task, index) =>
          task.id === this.taskSelected.id && this.taskSelected.index === index
      );
      delete this.taskSelected.index;
      if (paramLine === "" && this.getRTCmdLine.length === 0) paramLine = " ";
      pTask.params = paramLine;
    },
    okTaskClick() {
      if (
        this.templateTaskArray.length === 1 &&
        !this.templateTaskArray[0].caption
      ) {
        this.templateTaskArray = [];
      }
      for (let task of this.templateTaskArray) {
        if (task.params == null) {
          this.$store.commit(
            "setError",
            this.$t("templateTaskForm.youNeedEnterTaskParams") +
              ": " +
              task.caption
          );
          return;
        }
      }
      let nn = 1;
      for (let ob of this.templateTaskArray) {
        ob.nn = `${nn}`;
        ob.idTemplate = this.selectedTemplate.id;
        nn++;
      }
      let template = {
        idTemplate: this.selectedTemplate.id,
        tasks: this.templateTaskArray,
      };
      this.$store
        .dispatch("updCronTemplateTasks", template)
        .then(() => {
          this.$store.commit("setTasksFlag", false);
          this.templateTaskArray = [];
        })
        .catch((error) => {
          console.error(error);
        });
    },
    cancelTaskClick() {
      this.templateTaskArray = [];
      this.$store.commit("setTasksFlag", false);
    },
  },
  components: {
    RunTaskForm,
  },
  watch: {
    tasksFlag() {
      if (this.tasksFlag) this.setTemplateTasks();
    },
  },
  computed: {
    ...mapGetters([
      "tasksFlag",
      "selectedTemplate",
      "getAppsArray",
      "templateInfo",
      "packetableTaskList",
      "getRTCmdLine",
    ]),
  },
  mixins: [arrayWorkMixin],
};
</script>

<style scoped src="./items.css">
</style>

<style scoped>
.template-app-select {
  margin-bottom: 10px;
}
</style>